import {
  EggIcon,
  FishIcon,
  MilkIcon,
  NutIcon,
  PeanutIcon,
  SesameIcon,
  ShellIcon,
  ShrimpIcon,
  SoyIcon,
  WheatIcon,
  type IconComponent,
  type IconProps,
} from '@/components/icons';

/** Коды — из lib/allergens.ts; эмодзи оттуда остаются для админки. */
const ALLERGEN_ICONS: Record<string, IconComponent> = {
  fish: FishIcon,
  crustaceans: ShrimpIcon,
  molluscs: ShellIcon,
  gluten: WheatIcon,
  sesame: SesameIcon,
  soy: SoyIcon,
  egg: EggIcon,
  milk: MilkIcon,
  nuts: NutIcon,
  peanuts: PeanutIcon,
};

export function AllergenIcon({ code, ...props }: IconProps & { code: string }) {
  const Icon = ALLERGEN_ICONS[code];
  return Icon ? <Icon {...props} /> : null;
}
